import React from 'react'
import Card from 'react-bootstrap/Card';
import '../mysass.scss';
import {
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBRow,
  MDBCol
} from 'mdb-react-ui-kit';
import { Carousel, } from 'react-bootstrap';

const Lifestyle = () => {
  return (

    <>

<div className='anchorslifestyle' id='lifestyle' style={{textAlign:'center',fontSize:'16px'}}>
      Lifestyle of <b>KOSOVO</b>:
    </div>

    {/* <br></br> */}


<MDBRow className='m-1 row-cols-1 row-cols-md-3 g-4'>


<MDBCol>
      <Card className="bg-dark text-white">
    <Carousel interval={5000} fade style={{height:'550px'}} >
      

<Carousel.Item >
<Card.Img className='lifestyleimages' src="food.jpg" alt="Card image"  />
<Card.ImgOverlay style={{textAlign:'center'}}>
</Card.ImgOverlay>
<MDBCardBody>
      <MDBCardTitle>Traditional food</MDBCardTitle>
      <MDBCardText style={{fontSize:'14px'}}>
      The popular cuisine of Kosovo: The food is definitely another highlight of your vacation in Kosovo. Folk cuisine is the national cuisine of Kosovo. Kosovar specialties include gjyveç, burek, flia and kebab.
      Traditional Kosovar cuisine is in great demand among all visitors to Kosovo.

      </MDBCardText>
    </MDBCardBody>
</Carousel.Item>

<Carousel.Item >
<Card.Img className='lifestyleimages' src="food1.jpg" alt="Card image"  />
<Card.ImgOverlay style={{textAlign:'center'}}>
</Card.ImgOverlay>
<MDBCardBody>
      <MDBCardTitle>Traditional food</MDBCardTitle>
      <MDBCardText style={{fontSize:'14px'}}>
      It includes: dairy products such as cow's milk, sour cream, cream and cheese as well as vegetables such as beans, rice, peppers, tomatoes, onions, cabbage, cucumbers and much more.
Numerous restaurants offer traditional food that can be easily combined with modern food. The most popular Kosovar foods are flia, kebab, sausage, stuffed peppers, lamb, beans, sarma, buranijat, pitja, casserole and rice.
      </MDBCardText>
    </MDBCardBody>
</Carousel.Item>

</Carousel>
</Card>
</MDBCol>


<MDBCol>
      <Card className="bg-dark text-white">
    <Carousel interval={5000} fade style={{height:'550px'}} >
<Carousel.Item>
<Card.Img className='lifestyleimages' src="costume1.jpg" alt="Card image" />
<Card.ImgOverlay style={{textAlign:'center'}}>
</Card.ImgOverlay>
<MDBCardBody>
      <MDBCardTitle>
        National costumes
      </MDBCardTitle>
      <MDBCardText style={{fontSize:'14px'}}>
      The national costume of the Albanians National clothing or folk clothing is the clothing that 
      was worn by the Albanians in all traditional settlement areas inside and outside the state of 
      Albania in everyday life and on special occasions before western clothing started to be used 
      more and more.
      </MDBCardText>
    </MDBCardBody>
</Carousel.Item>


<Carousel.Item >
<Card.Img className='lifestyleimages' src="costume2.jpg" alt="Card image"  />
<Card.ImgOverlay style={{textAlign:'center'}}>
</Card.ImgOverlay>
<MDBCardBody>
      <MDBCardTitle>National costumes</MDBCardTitle>
      <MDBCardText style={{fontSize:'14px'}}>
              The folk costume was still widespread in everyday life until the 1950s. It has long been replaced by Western clothing, especially among younger people.

Today, individual pieces of traditional costumes are still worn by the elderly in everyday life, in folklore groups, on market days and on special occasions. Older rural men, for example, often still wear the qeleshe or plis, a round felt cap.      
      </MDBCardText>
    </MDBCardBody>
</Carousel.Item>
</Carousel>
</Card>
</MDBCol>


<MDBCol>
      <Card className="bg-dark text-white">
    <Carousel interval={5000} fade style={{height:'550px'}} >
<Carousel.Item>
<Card.Img className='lifestyleimages' src="nightlife.jpg" alt="Card image" />
<Card.ImgOverlay style={{textAlign:'center'}}>
</Card.ImgOverlay>
<MDBCardBody>
      <MDBCardTitle>Nightlife</MDBCardTitle>
      <MDBCardText style={{fontSize:'14px'}}>
      The Nightlife in Kosovo, especially in large cities, is abundant, where many clubs, bars and discos work until the morning, offering live music, dancing, entertainment. What is observed every evening is the extraordinary creativity of the young people who dance excellently where fun is observed to the maximum.


      </MDBCardText>
    </MDBCardBody>
</Carousel.Item>


<Carousel.Item >
<Card.Img className='lifestyleimages' src="nightlife1.jpg" alt="Card image"  />
<Card.ImgOverlay style={{textAlign:'center'}}>
</Card.ImgOverlay>
<MDBCardBody>
      <MDBCardTitle>Nightlife</MDBCardTitle>
      <MDBCardText style={{fontSize:'14px'}}>
      Although Prishtina is a city with 200,000 inhabitants, the number of visitors doubles at night and especially during the summer season, both from the smaller towns and from the large number of emigrants coming back home in the summer. There are a large number of bars in Pristina that organize live music with dance areas, some of which stand out, such as: Route B, Zone Club, Duplex, Diamond Club, Zanzibar and many other bars with live music.
      </MDBCardText>
    </MDBCardBody>
</Carousel.Item>
</Carousel>
</Card>
</MDBCol>



{/* ë */}
</MDBRow>

    </>
  )
}

export default Lifestyle